import { TradierSymbolParser } from '../tradier-symbol/TradierSymbolParser';

const parseUnderlyingSymbol = (_symbol?: string, maintainSPXW?: boolean) => {
  if (!_symbol || _symbol.length < 7) {
    return _symbol;
  }

  const parsed = new TradierSymbolParser(_symbol).parsed;

  return parsed?.underlyingSymbol;
};

export default parseUnderlyingSymbol;
